module.exports = __webpack_public_path__ + "img/slide-8-1.6e73d2cb.jpg";